import { FlatItem } from 'src/types/elements.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/cash-flows';

export const getCashFlowsDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
